export default "__VITE_PUBLIC_ASSET__4167ccba__"